const Panels = require('components/legacy/panels.js');

var salesButtonSelector = '[data-sale-button]',
  checkboxesSelector = '[data-toggle-sale]',
  bulkActionSelector = '[data-bulk-sale-action]',
  salesListingsContainerSelector = '[data-sales-listings-container]';

function init() {
  initEachSaleButton();

  // Certain AJAX'd forms load HTML with sale buttons that
  // necessitate re-initializing buttons in the DOM
  $(document).on('reverb.ajax_load.complete', salesListingsContainerSelector, function (e) {
    initEachSaleButton();
  });
}

function initEachSaleButton() {
  $(salesButtonSelector).each(initSaleButton);
}

function initSaleButton() {
  var $button = $(this);
  var saleButton = new Button($button);
  saleButton.init();
}

var Button = function ($button) {
  var self = this;
  self.$button = $button;
  self.$panel = null;
  var url = self.$button.prop('href');
  var onSaleClass = 'on-sale';

  self.init = function () {
    Panels.bindPanelTo($button, {
      ajaxUrl: url,
      loaded: panelLoaded,
      unhover: $button.parents('.product'),
      align: $button.data('align'),
      cssClass: 'sales-popout',
    });
  };

  function panelLoaded($panel) {
    self.$panel = $panel;
    initTips($panel);
    bindPanelEvents();
  }

  function numSalesSelected() {
    return self.$panel.find(checkboxesSelector).filter(':checked').length;
  }

  function runBulkAction(e) {
    e.preventDefault();

    var $this = $(this);
    var originalButtonText = $this.text();
    var errorContainer = $($this.data('error-selector'));
    errorContainer.hide();

    $this.prop('disabled', true);
    $this.addClass('btn-disabled');
    $this.text(I18n.t('js.wait'));

    $.post(this.href, function () {
      const msg = $this.data('success-message');
      $this.replaceWith(`<span class='color-green icon-l-check'>${msg}</span>`);
    }).fail(function () {
      $this.text(originalButtonText);
      errorContainer.show();
    });
  }

  function saleToggled(e) {
    var $checkbox = $(e.target);

    if (numSalesSelected() > 0) {
      $button.addClass(onSaleClass);
    } else {
      $button.removeClass(onSaleClass);
    }

    Reverb.RemoteCheckbox.submit($checkbox, {
      url: $checkbox.data('url'),
      done: toggleComplete,
    });
  }

  function bindPanelEvents() {
    self.$panel.find(checkboxesSelector).on('click', saleToggled);
    self.$panel.find(bulkActionSelector).on('click', runBulkAction);
  }

  function toggleComplete() {
    self.$panel.load(url, bindPanelEvents);
  }
};

module.exports = {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/sellers/sales_management.js